(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["two-ways"] && !Shopify.designMode) return;
  try {
    ////////////////////////
///////////////////////
// Two Ways to Shop Toggle
const toggleSwitch = document.querySelector('.toggle-switch');
const backgroundSlider = document.querySelector('.toggle-switch .background-slider');
const toggleContent = document.querySelectorAll('.toggle-content');

toggleSwitch.addEventListener('click', () => {
    // Toggle the "toggle" class on the background slider
    backgroundSlider.classList.toggle('toggle');

    // Toggle the "selected" class on the selected item
    toggleSwitch.querySelectorAll('p').forEach(item => {
        item.classList.toggle('selected');
    });

    toggleContent.forEach(item => {
        item.classList.toggle('hidden');
        item.classList.toggle('flex');
    });
});
  } catch(e) { console.error(e); }
})();

})();
